import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    button: {
        width: 145,
    },
    buttonWithStudyInfo: {
        width: 175,
        [theme.breakpoints.down('xs')]: {
            width: 125,
        },
    },
    buttonWrapper: {
        textAlign: 'center',
    },
    buttonGroupWrapper: {
        margin: '0 auto',
        marginTop: theme.spacing(5.5),
    },
}));
